// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Import server Config
import apiLink from '@configs/serverConfig'

// ** Axios Imports
import axios from 'axios'

// ** Rent
export const getServiceClientList = createAsyncThunk('appServiceClient/getServiceClientList', async params => {
    params.page = params.page === 0 ? 0 : params.page - 1    
    const response = await axios.post(apiLink('getServiceClients'), params)    
    
    return {
        params,
        data: response.data.content,
        totalPages: response.data.totalElements
    }
})
export const addServiceClient = createAsyncThunk('appServiceClient/addStation', async (data) => {
    const response = await axios.post(apiLink('addServiceClient'), data)
    return response.data
})
export const updateServiceClient = createAsyncThunk('appServiceClient/updateServiceClient', async (data) => {
    const response = await axios.put(apiLink({name: 'updateServiceClient', value: data.id}), data)
    return response.data
})
export const getServiceClient = createAsyncThunk('appServiceClient/getServiceClient', async (id) => {
    const response = await axios.get(apiLink({name: 'getServiceClient', value: id}))
    return response.data
})
export const removeServiceClient = createAsyncThunk('appServiceClient/removeServiceClient', async (id) => {
    const response = await axios.delete(apiLink({name: 'removeServiceClient', value: id}))
    return response.data
})

export const appServiceClientSlice = createSlice({
    name: 'appServiceClient',
    initialState: {
        clients: [],    
        total: 1,
        params: {},
        settings: [],
        selectedStation: null
    },
    reducers: {},
    extraReducers: builder => {
        builder
        .addCase(getServiceClientList.fulfilled, (state, action) => {
            state.clients = action.payload.data
            state.params = action.payload.params
            state.total = action.payload.totalPages
        })            
    }
})

export default appServiceClientSlice.reducer